import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/auth';
import Auth from '@rootCommon/types/auth';
import { ResultState } from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
export type AuthState = ResultState<Auth>;

const initialState: AuthState = {
  data: {
    loggedIn: false,
    accessToken: '',
    expirationDate: '',
    id: null,
    isForcePasswordChange: false,
    isForceConfirmProfile: false,
  },
  loading: false,
  error: null,
};

export const authReducer = (state = initialState, action: Action): AuthState => {
  switch (action.type) {
    case getType(actions.signInAdminPanel.request):
      return { ...state, loading: true, error: null };
    case getType(actions.signInAdminPanel.success):
      return { data: { ...state.data, ...action.payload, loggedIn: true }, loading: false, error: null };
    case getType(actions.signInAdminPanel.failure):
      return { ...state, loading: false, error: action.payload };

    case getType(actions.signOutUser):
      return {
        ...state, data: { ...state.data, loggedIn: false }, loading: false, error: null,
      };

    default:
      return state;
  }
};

export default authReducer;
